import _ from 'underscore';

/**
 * 피망 도메인의 베이스 도메인을 치환
 * @param {*} baseDomain 예) 베이스 도메인 game.daum.net
 */
function getDomainMappings(baseDomain) {
  return {
    '//www.pmang.com': '//pmang.' + baseDomain,
    '//file.pmang.com': '//pmfile.' + baseDomain,
    '//file.pmang.kr': '//pmfile.' + baseDomain,
    '//mm.file.com': '//mm.pmang.' + baseDomain,
    '//mm.file.kr': '//mm.pmang.' + baseDomain,
    '//memo.pmang.com': '//memo.pmang.' + baseDomain,
    '//chat.pmang.com': '//chat.pmang.' + baseDomain,
    '//member.pmang.com': '//pmangmember.' + baseDomain,
    '//pmangmall.pmang.com': '//mall.pmang.' + baseDomain,
    '//help.pmang.com': '//help.pmang.' + baseDomain,
    '//helpdesk.pmang.com': '//help.pmang.' + baseDomain, // 2022년 11월 고객센터 도메인 변경
    '//my.pmang.com': '//pmangmember.' + baseDomain,
    '//account.pmang.com': '//account.pmang.' + baseDomain,
    '//boardgame.pmang.com': '//boardgame.pmang.' + baseDomain,
    '//poker.pmang.com': '//poker.pmang.' + baseDomain,
    '//cs.pmang.com': '//cs.pmang.' + baseDomain,
    '//board.pmang.com': '//board.pmang.' + baseDomain,
    '//webboard-static.pmang.com': `//webboard-static.pmang.${baseDomain}`,
    '//webboard-static-dq.pmang.com': `//webboard-static-dq.pmang.${baseDomain}`,
    '//webboard-static-tq.pmang.com': `//webboard-static-tq.pmang.${baseDomain}`
  };
}

/**
 * 치환할 도메인의 배열을 만든다
 * [{ asis: '//www.pmang.com', tobe: '//pmang.game.daum.net'} ... ]
 * @param {*} maps
 */
function prepareList(mapping) {
  var keys = _.keys(mapping);
  var newMappings = [];

  _.each(keys, function (key) {
    newMappings.push({
      asis: key,
      tobe: mapping[key]
    });
  });

  return newMappings;
}

/**
 * 배열을 돌며 asis 의 값으로 정규표현식을 만든 후, tobe의 값으로 전부 치환한다.
 * @param {*} text 바꿀 텍스트
 * @param {*} list prepareList 로 만든 치환 목록
 */
function replaceAll(text, list) {
  var result = text;
  _.each(list, function (el) {
    result = result.replace(new RegExp(el.asis, 'g'), el.tobe);
  });
  return result;
}

/**
 * 다음 채널링 : 현재는 여기밖에 쓸 데가 없다.
 */
var replaceFn = {
  'boardgame.pmang.game.daum.net': function (text) {
    return replaceAll(text, prepareList(getDomainMappings('game.daum.net')));
  },
  'gostop.pmang.game.daum.net': function (text) {
    return replaceAll(text, prepareList(getDomainMappings('game.daum.net')));
  }
};

/**
 * 서버 패키지의 모듈과 이름은 같지만 초기화 과정과 내부 동작이 조금 다르다.
 * 이건 ES5로 브라우저 환경에서 실행 된다.
 */
export var domainReplacer = {
  create: function create() {
    var key = window.location.host; // 현재 도메인 주소에 따라 작동
    var fn = replaceFn[key];

    if (_.isFunction(fn)) {
      return fn;
    }
    return function (text) {
      return text; // noop
    };
  }
};
